export const setPayrolls = (state, info) => {
  console.log('Payrolls --> ', info)
  state.payrolls = info
}

export const setPendingPayrolls = (state, info) => {
  console.log('Pending payrolls --> ', info)
  state.pendingPayrolls = info
}
